// extracted by mini-css-extract-plugin
module.exports = {"input":"FieldCurrencyInput_input__2Qvnr","inputSuccess":"FieldCurrencyInput_inputSuccess__jl1Od","inputError":"FieldCurrencyInput_inputError__35Udj"};